import React, { Component } from "react";
import { Form, Select, TreeSelect } from "antd";

const { TreeNode } = TreeSelect;
import { FormComponentProps } from "antd/lib/form";
import axios from "../lib/api.request";
interface iState {
  data: Array<any>;
}
function getUrlParam() {
  let url = window.location.search;
  let objRequest = {};
  if (url.indexOf("?") !== -1) {
    url = url.split("?")[1];
    let strArr = url.split("&");
    for (let i = 0; i < strArr.length; i++) {
      objRequest[strArr[i].split("=")[0]] = decodeURI(strArr[i].split("=")[1]);
    }
  }
  return objRequest;
}
interface iProps extends FormComponentProps {
  fieldsName?: object;
  treeNodeLabelProp?: string;
  dataApi?: string;
  /** 选项数据 */
  selectList?: Array<any>;
  // 是否可以清除
  allowClear?: boolean;

  // 是否可以多选
  multiple?: boolean;
  /** 默认的选中项 */
  defaultValue?: string;
  /** 指定选中项 */
  value?: string;
  /** 选择完成后的回调 */
  onChange?: (value: any) => void;
  /** 默认值 */
  placeholder?: string;
  treeCheckable?: boolean;
  extendPropFiled?:string
}

export class TreeCommonSelect extends Component<iProps, iState> {
  state: iState = {
    data: [],
  };
  async componentDidMount() {
    let data;
    if (this.props.dataApi) {
      let res = await this.getData();
      data = res.data;
    } else {
      data = this.props.selectList ?? [];
    }
    this.setState({
      data,
    });
  }
  getData = () => {
    return axios.request({
      url: this.props.dataApi, //"https://bs-application-resource.oss-cn-beijing.aliyuncs.com/pc/dynamicUI/d",
      method: "get",
      params: { ...getUrlParam() },
    });
  };
  getValue=(item,fields)=>{

    let itemFields=  (fields??[])?.map(fieldsItem=>item?.[fieldsItem])
    
    return itemFields.join("_")

  }
  getTreeData = (fieldsName, data, fields) => {
    let nodes = (data ?? []).map((item) => (
      <TreeNode
        selectable={item?.clickType==='action'}
        value={this.getValue(item,fields)}
        title={item?.[fieldsName["name"]]}
        key={this.getValue(item,fields)+"_"+item?.[this.props.extendPropFiled]}
      >
        {
          this.getTreeData(fieldsName,item?.[fieldsName["subNodes"]] ?? [],fields)
        }
      </TreeNode>
    ));
    return nodes;
  };
  render() {
    let fieldsName = this.props.fieldsName ?? {
      id: "id",
      name: "name",
      subNodes: "subNodes",
    };
    let fields = fieldsName["id"].split("_") ?? [];

    return (
      <TreeSelect
        style={{ width: "100%" }}
        dropdownStyle={{ maxHeight: 200, overflow: "auto" }}
        {...this.props}
      >
        {this.getTreeData(fieldsName, this.state.data, fields)}
    
      </TreeSelect>
    );
  }
}

const mapPropsToFields = (props) => {
  return {};
};

export default Form.create({ mapPropsToFields })(TreeCommonSelect);
